<template>
    <header class="mb-4">
        <div class="sticky-old">

            <span v-show="!onSearch">
                <heading class="hidden-mobile">{{ desktopTitle }}</heading>
                <heading class="hidden-desktop">{{ mobileTitle }}</heading>
                <div class="actions">
                    <a href="#" v-show="hasSearch" @click.prevent="showSearch()">
                        <i class="fa fa-search" aria-hidden="true"></i>
                    </a>
                </div>
            </span>
            <span v-show="onSearch">
                <input type="text" ref="query" v-model="query"/>
                <div class="actions">
                    <a href="#" @click.prevent="hideSearch()" class="close-search">
                        <i class="fa fa-times" aria-hidden="true"></i>
                    </a>
                </div>
            </span>

        </div>
        <div class="buffer"></div>
    </header>
</template>

<script>
    export default {
        props: ['title', 'searchable'],
        data() {
            return {
                onSearch: false,
                filtersSetBefore:false,
                query: '',
                desktopTitle: '',
                mobileTitle: ''
            }
        },
        watch: {
            query(query) {
                eventBus.$emit('list-view-search-query-changed-'+this.name, query);
            }
        },
        computed: {
            hasSearch() {
                return this.searchable === "true";
            },
            name(){
                return this.$parent.name;
            }
        },
        methods: {
            showSearch() {
                var that = this;
                this.onSearch = true;
                eventBus.$emit('list-view-search-shown-'+this.name);
                window.setTimeout(function(){
                    that.$refs.query.focus();
                },50);
            },
            hideSearch() {
                this.onSearch = false;
                this.query = '';
                eventBus.$emit('list-view-search-hidden-'+this.name);
            }
        },
        mounted() {
            var that = this;
            this.desktopTitle = this.title;
            this.mobileTitle = this.title;
            this.filtersSetBefore = false;
            eventBus.$on('filter-bar-set-filters',function(){
                if(!that.filtersSetBefore){
                    that.mobileTitle = 'All';
                    that.filtersSetBefore = true;
                }
            });
            eventBus.$on('filter-bar-changed',function(filtername,human_name){

                if(_.isNull(filtername) || filtername == '')
                {
                    that.mobileTitle = 'All';
                }else{
                    that.mobileTitle = human_name;
                }
            });
        }
    }
</script>

<style lang="scss">
    header {
        position: relative;
        @include clearfix();

    }

    div.sticky-old {
        position: absolute;
        width: 100%;
        z-index: 2;
        input {
            width: 85%;
            padding: 0.3em;
            float: left;
        }
    }

    div.buffer {
        height: 35px;
        position: relative;
        z-index: 1;
    }

    .actions {
        float: right;
        a {
            float: none !important;
            display: inline-block;
            margin-right:5px;
            &:last-of-type{
                margin-right:0;
            }
        }
    }

    .close-search{
        margin-top:3px;
    }
</style>
